//------------------
// NPM libarys 
//------------------
import Matter from 'matter-js';
const stripe = Stripe('pk_live_JsxhR4KTB6QwULcTPvtbAOyh');

//------------------
// Data
//------------------

function isTouchDevice() {
    return window.ontouchstart !== undefined;
}

var touchDev = isTouchDevice();

var assetUrl = '/assets/imgs/final_small';
var silhouettetUrl = '/assets/imgs/silhouette';

var mutliplyer = 0.0001;
var staticTime = 2000;

var loaded = false;


var objs = [
    {
    title: "FORM 1",
    filename: "form_1.png",
    desctiption: "",
    svgCode: "95.51 1857.25 .64 1613.3 .64 1030.52 61.17 773.02 .64 522.29 1145.86 522.29 1071.32 725.58 1172.96 998.09 1172.96 1328.69 1172.96 1626.85 1103.17 1857.25 1006.17 1958.9 239.17 1958.9 158.17 1915.09",
    img: "/assets/imgs/final_small/form_1.png",
    stripe_id: "prod_NxH1KN3lNXsHdH",
    width: 1042,
    height: 1342
    },
    {
    title: "FORM 2",
    filename: "form_2.png",
    desctiption: "",
    svgCode: "1466.11 1864.03 1396.59 1599.74 1369.48 1157.09 1369.48 861.11 1466.11 615.09 1417.79 325.77 2575.69 325.77 2481.11 573.09 2535.03 786.57 2575.69 1094.9 2575.69 1389.67 2535.03 1620.07 2446.94 1915.09 2338.51 1958.9 1593.1 1958.9 1525.34 1915.09",
    img: "/assets/imgs/final_small/form_2.png",
    stripe_id: "prod_NxH3hlGSwI4It7",
    width: 1056,
    height: 1516
    },
    {
    title: "FORM 3",
    filename: "form_3.png",
    desctiption: "",
    svgCode: "2948.6 1809.81 2879.11 1518.43 2879.11 998.09 2879.11 615.09 3077.15 325.77 3077.15 .5 3887.11 .5 3887.11 203.79 3985.19 366.43 4107.17 573.09 4141.05 905.16 4141.05 1376.12 4100.39 1755.6 4012.3 1958.9 3144.91 1958.9 3016.16 1877.58",
    img: "/assets/imgs/final_small/form_3.png",
    stripe_id: "prod_NxH4Uo0zkZl4Ul",
    width: 1122,
    height: 1834
    },
    {
    title: "FORM 4",
    filename: "form_4.png",
    desctiption: "",
    svgCode: "4778.04 1870.8 4684.19 1538.76 4615.4 1175.09 4696.72 894.99 4684.19 522.29 5718.74 522.29 5747.07 615.09 5718.74 752.69 5747.07 979.7 5801.28 1265.09 5747.07 1633.63 5638.65 1915.09 5547.46 1958.9 4872.91 1958.9 4815.31 1901.3",
    img: "/assets/imgs/final_small/form_4.png",
    stripe_id: "prod_NxH45rPjcTH5bS",
    width: 986,
    height: 1300
    },
    {
    title: "FORM 5",
    filename: "form_5.png",
    desctiption: "",
    svgCode: "6223.88 1813.2 6150.27 1592.97 6129.94 1095.09 6176.91 793.35 6194.32 386.76 7083.88 386.76 7068.48 562.95 7083.88 769.63 7139.63 989.86 7156.57 1393.06 7139.63 1691.23 7083.88 1891.13 7031.21 1941.95 6299.35 1941.95 6251.92 1870.8",
    img: "/assets/imgs/final_small/form_5.png",
    stripe_id: "prod_NxH5tnNjGjcDE4",
    width: 860,
    height: 1480
    },
    {
    title: "FORM 6",
    filename: "form_6.png",
    desctiption: "",
    svgCode: "7586.13 1823.37 7515.73 1376.12 7515.73 854.33 7550.93 583.28 7624.15 468.08 7586.13 224.12 8559.3 224.12 8525.63 435.09 8593.13 615.09 8647.39 827.23 8647.39 1175.09 8647.39 1708.17 8593.13 1870.8 8525.63 1958.9 7922.31 1958.9 7691.91 1958.9 7624.15 1915.09",
    img: "/assets/imgs/final_small/form_6.png",
    stripe_id: "prod_NxH7U0wveMtDWQ",
    width: 1007,
    height: 1640
    },
    {
    title: "FORM 7",
    filename: "form_7.png",
    desctiption: "",
    svgCode: "9045.17 1884.36 8961.63 1633.63 8911.68 1328.69 8911.68 1057.63 9045.17 745.91 9045.17 386.76 10009.46 386.76 9968.8 615.09 10045.17 793.35 10138.21 1057.63 10138.21 1484.54 10045.17 1836.92 9941.7 1958.9 9223.39 1958.9 9101.42 1915.09",
    img: "/assets/imgs/final_small/form_7.png",
    stripe_id: "prod_NxH9XpwYwemalD",
    width: 1000,
    height: 1412
    },
    {
    title: "FORM 8",
    filename: "form_8.png",
    desctiption: "",
    svgCode: "10602.4 1853.86 10534.64 1745.44 10507.53 1552.31 10507.53 1250.59 10507.53 996.64 10554.97 796.73 10541.41 514.09 11463.01 514.09 11442.68 708.64 11463.01 864.5 11483.34 1061.02 11483.34 1185.59 11483.34 1372.73 11466.4 1637.01 11442.68 1809.81 11425.72 1894.52 11378.31 1958.9 10724.38 1958.9 10644.07 1897.91",
    img: "/assets/imgs/final_small/form_8.png",
    stripe_id: "prod_NxHA7Fg3zbaTfT",
    width: 854,
    height: 1329
    },
    {
    title: "FORM 9",
    filename: "form_9.png",
    desctiption: "",
    svgCode: "11842.49 1874.19 11760.44 1738.66 11700.19 1511.65 11676.47 1182.99 11720.52 844.17 11744.23 739.13 11659.53 430.81 11700.19 407.09 12625.17 407.09 12658.44 434.19 12642.12 542.62 12591.29 698.48 12682.77 864.5 12730.21 1094.9 12716.66 1349.01 12682.77 1626.85 12658.44 1874.19 12621.79 1915.09 12581.13 1958.9 11937.36 1958.9 11879.76 1915.09",
    img: "/assets/imgs/final_small/form_9.png",
    stripe_id: "prod_NxHBMMib41BBDB",
    width: 898,
    height: 1459
    },
    {
    title: "FORM 10",
    filename: "form_10.png",
    desctiption: "",
    svgCode: "210.71 3985.06 158.17 3510.7 158.17 3244.16 210.71 2986.66 264.92 2860.16 192.63 2580.07 1055.5 2580.07 1103.17 2621.55 1060.02 2837.58 1103.17 3013.76 1159.41 3253.2 1159.41 3497.15 1159.41 3804.35 1123.27 3985.06 1069.06 4065.55 1006.17 4098 368.82 4098 310.09 4065.55 239.17 4034.75",
    img: "/assets/imgs/final_small/form_10.png",
    stripe_id: "prod_NxHB9oJUj6sTy8",
    width: 864,
    height: 1444
    },
    {
    title: "FORM 11",
    filename: "form_11.png",
    desctiption: "",
    svgCode: "1498.23 3994.09 1439.5 3790.8 1380.77 3424.87 1403.36 2927.93 1466.11 2647.84 1534.37 2412.92 1489.2 2182.52 1484.68 2110.24 2446.94 2110.24 2415.31 2259.32 2374.65 2358.71 2446.94 2534.89 2510.18 2720.12 2532.77 2936.96 2532.77 3189.95 2532.77 3551.36 2501.15 3817.9 2451.45 3994.09 2401.76 4098 1778.33 4098 1620.21 4098 1547.93 4065.55",
    img: "/assets/imgs/final_small/form_11.png",
    stripe_id: "prod_NxHCn538PES9r7",
    width: 1015,
    height: 1902
    },
    {
    title: "FORM 12",
    filename: "form_12.png",
    desctiption: "",
    svgCode: "2903.22 3966.99 2807.61 3763.69 2781.24 3379.69 2807.61 3054.42 2948.6 2715.6 2989.05 2621.55 2930.32 2449.06 3829.33 2449.06 3802.23 2562 3779.64 2621.55 3860.96 2787.88 3924.2 2932.45 3958.61 3208.02 3928.72 3461.01 3887.11 3777.25 3851.92 4034.75 3815.78 4098 3052.3 4098 2948.6 4034.75",
    img: "/assets/imgs/final_small/form_12.png",
    stripe_id: "prod_NxHDqMzl4xnxGe",
    width: 1008,
    height: 1576
    },
    {
    title: "FORM 13",
    filename: "form_13.png",
    desctiption: "",
    svgCode: "4240.44 4003.13 4141.05 3822.42 4118.46 3470.05 4118.46 2918.89 4217.85 2674.94 4263.03 2539.41 4222.37 2288.55 5130.41 2288.55 5107.82 2417.44 5076.2 2557.48 5130.41 2679.46 5208.34 2824.02 5225.74 2941.48 5247.87 3145.84 5247.87 3366.14 5247.87 3664.3 5208.34 3903.74 5112.34 4065.55 5012.95 4098 4683.17 4120.59 4439.21 4120.59 4303.69 4065.55",
    img: "/assets/imgs/final_small/form_13.png",
    stripe_id: "prod_NxHFH7AI0xFpKA",
    width: 998,
    height: 1706
    },
    {
    title: "FORM 14",
    filename: "form_14.png",
    desctiption: "",
    svgCode: "5547.46 3930.85 5491.82 3655.27 5460.2 3384.21 5460.2 3063.46 5527.97 2724.64 5577.66 2523.55 5547.46 2205.11 6545.46 2205.11 6545.46 2399.37 6545.46 2575.55 6585.09 2711.08 6621.23 2927.93 6643.26 3177.05 6621.23 3424.87 6598.65 3736.59 6517.33 4065.55 6445.05 4098 5636.39 4098 5582.18 4012.16",
    img: "/assets/imgs/final_small/form_14.png",
    stripe_id: "prod_NxHFyiRauTmdaX",
    width: 998,
    height: 1777
    },
    {
    title: "FORM 15",
    filename: "form_15.png",
    desctiption: "",
    svgCode: "6869.39 3944.4 6806.46 3745.62 6806.46 3456.49 6806.46 3004.73 6905.84 2765.29 6869.39 2580.07 6856.15 2430.99 7737.09 2430.99 7755.16 2523.55 7719.02 2647.84 7810.39 2846.61 7859.07 3063.46 7877.14 3294.55 7877.14 3546.85 7831.96 3867.6 7782.27 4025.72 7737.09 4098 6991.68 4098 6905.84 4016.68",
    img: "/assets/imgs/final_small/form_15.png",
    stripe_id: "prod_NxHGLCnKaCAYAN",
    width: 941,
    height: 1542
    },
    {
    title: "FORM 16",
    filename: "form_16.png",
    desctiption: "",
    svgCode: "8125.61 4003.13 8048.81 3745.62 8012.67 3492.63 8030.74 3086.05 8089.63 2824.02 8125.61 2643.32 8125.61 2358.71 8911.68 2358.71 8911.68 2571.04 8961.63 2717.55 8992.99 2882.75 9045.17 3177.05 9045.17 3497.15 8997.51 3863.08 8911.68 4065.55 8803.25 4098 8220.48 4098 8166.27 4065.55",
    img: "/assets/imgs/final_small/form_16.png",
    stripe_id: "prod_NxHH1IQbTA3FuT",
    width: 872,
    height: 1573
    },
    {
    title: "FORM 17",
    filename: "form_17.png",
    desctiption: "",
    svgCode: "9330.16 3980.54 9259.53 3741.1 9218.88 3357.11 9330.16 2982.14 9330.16 2824.02 9330.16 2647.84 10221.79 2647.84 10221.79 2819.51 10221.79 2973.11 10300.85 3151.55 10378.39 3339.03 10325.7 3795.32 10221.79 4065.55 10108.85 4134.14 9467.35 4134.14 9367.96 4065.55",
    img: "/assets/imgs/final_small/form_17.png",
    stripe_id: "prod_NxHIzD4Yu01z4U",
    width: 936,
    height: 1348
    },
    {
    title: "FORM 18",
    filename: "form_18.png",
    desctiption: "",
    svgCode: "10649.84 3988.44 10575.3 3849.53 10541.41 3642.85 10521.08 3442.94 10561.74 3243.03 10602.55 3127.83 10568.52 2789.01 11562.55 2789.01 11544.33 2951.65 11530.78 3087.18 11584.99 3202.38 11618.87 3317.58 11618.87 3466.66 11618.87 3612.35 11618.87 3829.2 11547.72 3971.5 11469.79 4098 10771.81 4098 10697.27 4042.66",
    img: "/assets/imgs/final_small/form_18.png",
    stripe_id: "prod_NxHIQPe85GQw2i",
    width: 960,
    height: 1169
    },
    {
    title: "FORM 19",
    filename: "form_19.png",
    desctiption: "",
    svgCode: "11876.38 3971.5 11815.39 3707.22 11815.39 3443.5 11815.39 3192.21 11859.43 2938.09 11876.38 2812.73 11876.38 2609.44 12765.92 2609.44 12765.92 2758.52 12801.36 2944.87 12818.3 3100.73 12818.3 3239.65 12818.3 3592.02 12797.97 3822.42 12742.75 4020.55 12682.77 4123.14 12001.74 4123.14 11910.26 4042.66",
    img: "/assets/imgs/final_small/form_19.png",
    stripe_id: "prod_NxHJAw8vpbPuHO",
    width: 890,
    height: 1386
    },
    {
    title: "FORM 20",
    filename: "form_20.png",
    desctiption: "",
    svgCode: "151.96 6203.71 19.4 5993.64 19.4 5776.79 19.4 5463.29 95.67 5316 95.67 5044.94 1090.79 5044.94 1068.67 5255.01 1159.41 5519.7 1159.41 5803.9 1090.79 6068.18 1001.99 6271.7 900.34 6332.7 263.35 6332.7 188.81 6271.7",
    img: "/assets/imgs/final_small/form_20.png",
    stripe_id: "prod_NxHJphICLOroH8",
    width: 973,
    height: 1166
    },
    {
    title: "FORM 21",
    filename: "form_21.png",
    desctiption: "",
    svgCode: "1406.32 6126.91 1380.77 5932.65 1369.48 5593.83 1387.9 5282.11 1445.61 5137.55 1445.61 4740 2293.61 4740 2293.61 4983.95 2332.43 5187.24 2364.06 5372.47 2364.06 5688.7 2364.06 6077.22 2314.36 6190.16 2237.56 6332.7 1537.33 6332.7 1445.61 6203.71",
    img: "/assets/imgs/final_small/form_21.png",
    stripe_id: "prod_NxHKtmAFmmZIYd",
    width: 848,
    height: 1434
    },
    {
    title: "FORM 22",
    filename: "form_22.png",
    desctiption: "",
    svgCode: "2739.02 6181.12 2657.7 5968.79 2608.01 5688.82 2635.11 5386.02 2710.93 5128.51 2838.41 4837.7 2723.21 4604.47 2748.05 4523.15 3845.84 4523.15 3873.93 4586.4 3812.98 4837.7 3832.29 4943.29 3873.93 5083.34 3909.09 5214.35 3958.61 5431.2 3958.61 5629.97 3931.68 5869.41 3909.09 6023.01 3873.93 6181.12 3805.18 6286.29 3714.83 6332.7 2901.65 6332.7 2811.3 6271.7",
    img: "/assets/imgs/final_small/form_22.png",
    stripe_id: "prod_NxHK2HNbEe7y3i",
    width: 1163,
    height: 1646
    },
    {
    title: "FORM 23",
    filename: "form_23.png",
    desctiption: "",
    svgCode: "4144 6226.3 4062.69 6045.59 4017.51 5860.37 4035.58 5536.35 4107.67 5282.11 4216.29 4992.98 4116.9 4681.27 5210.17 4681.27 5128.85 4961.36 5210.17 5087.85 5258.67 5245.97 5300.52 5399.57 5332.14 5629.97 5309.56 6086.25 5277.93 6271.7 5192.1 6393.45 4302.12 6393.45 4202.73 6305.7",
    img: "/assets/imgs/final_small/form_23.png",
    stripe_id: "prod_NxHLZa0p6d5sFs",
    width: 1151,
    height: 1556
    },
    {
    title: "FORM 24",
    filename: "form_24.png",
    desctiption: "",
    svgCode: "5585.13 6286.29 5508.33 6086.25 5460.2 5801.64 5460.2 5462.03 5547.56 5047.2 5460.2 4640.29 6479.62 4640.29 6417.06 5024.61 6479.62 5178.21 6520.28 5363.43 6550.73 5537.36 6550.73 5833.26 6511.25 6032.04 6417.06 6286.29 6371.2 6393.45 5698.07 6393.45 5621.27 6332.7",
    img: "/assets/imgs/final_small/form_24.png",
    stripe_id: "prod_NxHMfL8yYnN3ab",
    width: 900,
    height: 1572
    },
    {
    title: "FORM 25",
    filename: "form_25.png",
    desctiption: "",
    svgCode: "6806.46 6239.85 6700.99 6027.52 6643.26 5756.47 6643.26 5427.93 6678.4 5114.96 6904.28 4798.73 6836.52 4473.46 7834.91 4473.46 7776.19 4776.7 7877.14 4884.56 7988.51 5065.27 8065.31 5356.65 8047.24 5760.98 7970.44 6122.39 7843.95 6393.45 6899.76 6393.45 6850.07 6305.7",
    img: "/assets/imgs/final_small/form_25.png",
    stripe_id: "prod_NxHMtVNmwpbzWs",
    width: 1184,
    height: 1750
    },
    {
    title: "FORM 26",
    filename: "form_26.png",
    desctiption: "",
    svgCode: "8286.68 6286.29 8178.26 6027.52 8144.37 5668.37 8178.26 5316 8286.68 5078.82 8215.53 4776.7 8252.63 4681.27 9276.04 4681.27 9330.63 4787.7 9276.04 5044.94 9398.02 5295.67 9438.68 5554.7 9438.68 5871.66 9370.91 6129.17 9248.94 6393.45 9218.88 6474.77 8408.65 6474.77 8334.13 6393.45",
    img: "/assets/imgs/final_small/form_26.png",
    stripe_id: "prod_NxHNjPBfNScgHO",
    width: 1078,
    height: 1534
    },
    {
    title: "FORM 27",
    filename: "form_27.png",
    desctiption: "",
    svgCode: "9579.67 6280.51 9533.55 6140.46 9492.89 5887.48 9492.89 5519.7 9536.28 5300.18 9632.93 5124 9632.93 4733.7 10459.66 4733.7 10459.66 4988.47 10540.98 5142.07 10599.71 5264.04 10599.71 5462.03 10581.64 5905.55 10554.53 6235.33 10510.67 6393.45 9682.63 6393.45 9619.38 6339.7",
    img: "/assets/imgs/final_small/form_27.png",
    stripe_id: "prod_NxHOnQmrN02QOx",
    width: 931,
    height: 1502
    },
    {
    title: "FORM 28",
    filename: "form_28.png",
    desctiption: "",
    svgCode: "10766.86 6286.29 10708.13 5873.92 10708.13 5476.37 10708.13 5227.9 10766.86 5069.78 10766.86 4681.27 11593.59 4681.27 11618.87 4884.56 11670.39 5069.78 11724.6 5241.45 11724.6 6262.44 11589.07 6393.45 10952.08 6393.45 10830.11 6339.7",
    img: "/assets/imgs/final_small/form_28.png",
    stripe_id: "prod_NxHOwgCnUqg4Tk",
    width: 824,
    height: 1508
    },
    {
    title: "FORM 29",
    filename: "form_29.png",
    desctiption: "",
    svgCode: "11896.27 6212.75 11837.54 5977.83 11837.54 5715.81 11896.27 5435.71 11924.35 5277.6 11837.54 5007.29 11837.54 4884.56 12781.73 4884.56 12761.85 5078.82 12709.35 5291.15 12781.73 5426.68 12818.3 5760.98 12781.73 6167.57 12677.82 6339.7 12013.73 6339.7 11924.35 6266.96",
    img: "/assets/imgs/final_small/form_29.png",
    stripe_id: "prod_NxHPHsNNJ0s0b3",
    width: 785,
    height: 1279
    },
    {
    title: "FORM 30",
    filename: "form_30.png",
    desctiption: "",
    svgCode: "123.31 7952.04 95.67 7617.73 55.54 7319.57 123.31 7098.2 123.31 6971.71 19.4 6763.9 19.4 6700.65 1094.6 6700.65 1094.6 6799.16 990.69 6958.16 986.18 7075.62 1044.9 7274.39 1035.87 7531.9 1031.35 7848.13 981.66 8052.16 882.27 8128.22 218.18 8128.22 151.96 8024.32",
    img: "/assets/imgs/final_small/form_30.png",
    stripe_id: "prod_NxHPaN3aH5J1wL",
    width: 792,
    height: 1262
    },
    {
    title: "FORM 31",
    filename: "form_31.png",
    desctiption: "",
    svgCode: "1311.45 8019.8 1311.45 7391.85 1311.45 7012.37 1369.48 6899.43 1243.68 6551.57 2413.75 6551.57 2293.61 6845.22 2323.4 7202.11 2341.47 7825.54 2323.4 8019.8 2165.28 8177.92 1478.6 8177.92 1369.48 8087.57",
    img: "/assets/imgs/final_small/form_31.png",
    stripe_id: "prod_NxHQDENxlHHueH",
    width: 892,
    height: 1438
    },
    {
    title: "FORM 32",
    filename: "form_32.png",
    desctiption: "",
    svgCode: "2748.05 7947.52 2657.7 7703.57 2657.7 7342.16 2748.05 7116.27 2702.88 6808.16 2710.93 6700.65 3746.45 6700.65 3683.24 7025.92 3782.59 7211.14 3782.59 7414.44 3782.59 7721.64 3710.31 7947.52 3633.51 8128.22 2856.48 8128.22 2798.53 8007.03",
    img: "/assets/imgs/final_small/form_32.png",
    stripe_id: "prod_NxHQWi0scKeP85",
    width: 902,
    height: 1244
    },
    {
    title: "FORM 33",
    filename: "form_33.png",
    desctiption: "",
    svgCode: "4139.49 7902.34 4076.24 7708.08 4076.24 7396.37 4182.4 7143.38 4076.24 6781.97 5115.3 6781.97 5020.43 7102.72 5115.3 7233.73 5115.3 7396.37 5115.3 7649.36 5079.16 7834.58 5006.87 8024.32 4970.73 8101.12 4270.5 8101.12 4165.46 7996.08",
    img: "/assets/imgs/final_small/form_33.png",
    stripe_id: "prod_NxHR7HLSImr1ti",
    width: 866,
    height: 1226
    },
    {
    title: "FORM 34",
    filename: "form_34.png",
    desctiption: "",
    svgCode: "1941.02 6183.66 1867.28 6007.02 1849.21 5844.83 1849.21 5645.71 1895.11 5483.42 1912.03 5334.34 1912.03 5212.36 1895.11 5072.32 1895.11 4959.38 2771.63 4959.38 2740.58 5122.01 2740.58 5216.88 2771.63 5427.22 2812.33 5576.03 2812.33 5725.12 2812.33 6007.01 2771.63 6183.66 2662.38 6310.15 2486.2 6341.77 2271.51 6341.77 2038.95 6269.49 1977.16 6248.29",
    img: "/assets/imgs/final_small/form_34.png",
    stripe_id: "prod_NxIwUTmcbkxkZZ",
    width: 724,
    height: 1086
    },
    {
    title: "FORM 35",
    filename: "form_35.png",
    desctiption: "",
    svgCode: "5756.8 6817.16 5942.02 6718.72 6249.22 6632.89 6678.4 6632.89 7039.81 6781.97 7220.52 6971.71 7341.8 7193.07 7374.12 7545.45 7319.9 7897.83 7152.75 8241.17 6917.83 8397.95 6619.67 8512.22 6258.26 8485.12 6002.73 8421.87 5756.8 8290.86 5552.73 8046.91 5460.2 7667.43 5460.2 7360.23 5580.61 7025.92 5702.59 6890.39",
    img: "/assets/imgs/final_small/form_35.png",
    stripe_id: "prod_NxHSKRDHC2vyD3",
    width: 1739,
    height: 1705
    },
    {
    title: "FORM 36",
    filename: "form_36.png",
    desctiption: "",
    svgCode: "7554.82 7825.54 7514.16 7545.45 7534.49 7378.3 7609.03 7147.9 7780.7 6908.46 8065.31 6763.9 8363.48 6727.76 8697.78 6772.93 8901.08 6926.53 9082.13 7125.31 9149.55 7360.23 9172.14 7667.43 9082.13 7970.11 8937.22 8205.02 8702.3 8345.07 8462.87 8397.95 8164.7 8397.95 7839.43 8272.79 7712.94 8150.81 7586.13 7943",
    img: "/assets/imgs/final_small/form_36.png",
    stripe_id: "prod_NxHSSj1DRpHCCQ",
    width: 1496,
    height: 1504
    },
    {
    title: "FORM 37",
    filename: "form_37.png",
    desctiption: "",
    svgCode: "9589.35 7963.82 9537.24 7604.84 9563.29 7390.61 9658.83 7095.32 9878.85 6788.45 10243.62 6603.16 10625.76 6556.84 11054.23 6614.74 11314.78 6811.61 11546.82 7066.37 11633.23 7367.45 11662.18 7761.17 11546.82 8149.1 11361.1 8450.19 11060.02 8629.68 10753.14 8697.45 10371 8697.45 9954.12 8537.04 9792 8380.7 9629.47 8114.36",
    img: "/assets/imgs/final_small/form_37.png",
    stripe_id: "prod_NxHTWYmtXJzv6K",
    width: 1974,
    height: 1936
    },
    {
    title: "FORM 38",
    filename: "form_38.png",
    desctiption: "",
    svgCode: "12035.93 7944.14 11995.57 7666.16 12015.75 7500.27 12089.73 7271.61 12260.1 7033.98 12542.57 6890.51 12838.48 6854.64 13170.26 6899.47 13372.02 7051.91 13551.7 7249.19 13618.62 7482.33 13641.03 7787.21 13551.7 8087.61 13407.89 8320.76 13174.75 8459.75 12937.12 8512.22 12641.2 8512.22 12318.39 8388.01 12192.85 8266.95 12066.99 8060.71",
    img: "/assets/imgs/final_small/form_38.png",
    stripe_id: "prod_NxHUvhsfks4ZLB",
    width: 1416,
    height: 1430
    },
    {
    title: "FORM 39",
    filename: "form_39.png",
    desctiption: "",
    svgCode: "5379.15 10306.75 5332.14 9982.92 5355.65 9789.67 5441.83 9523.29 5640.3 9246.47 5969.36 9079.33 6314.08 9037.55 6700.59 9089.78 6935.63 9267.36 7144.95 9497.18 7222.9 9768.78 7249.01 10123.95 7144.95 10473.89 6977.41 10745.49 6705.81 10907.41 6428.99 10968.54 6084.27 10968.54 5708.2 10823.84 5561.96 10682.82 5415.34 10442.55",
    img: "/assets/imgs/final_small/form_39.png",
    stripe_id: "prod_NxHU26XB0kL6Is",
    width: 1800,
    height: 1786
    },
    {
    title: "FORM 40",
    filename: "form_40.png",
    desctiption: "",
    svgCode: "8322.57 10619.7 7897.47 9438.66 8040.02 9393.16 9549.59 9393.16 9685.79 9529.36 9401.85 10710.66 9279.87 10748.45 8419.26 10748.45 8344.72 10646.81",
    img: "/assets/imgs/final_small/form_40.png",
    stripe_id: "prod_NxHVuR398CsWUf",
    width: 1568,
    height: 1272
    }
    ];

//------------------
// APP 
//------------------



var right_wall = false;
var containerHeight = false


window.addEventListener('load', function() {

    if (!document.body.classList.contains('initial')) {

        var bodies = [];

        var numElements = objs.length;
        var containerWidth = window.innerWidth;
        var gutterWidth = (containerWidth - (1 * window.innerWidth / 1)) / 1;
        var elementHeight =  0.92 * window.innerWidth;
        containerHeight = numElements * elementHeight + 10;
        var numVerticalGutters = 1; // 3 elements per row
        var verticalGutterHeight = (containerHeight - (Math.ceil(numElements / 1) * elementHeight)) / numVerticalGutters;

        if (window.innerWidth > 800) {
            gutterWidth = (containerWidth - (3 * window.innerWidth / 3)) / 4;
            elementHeight = (window.innerWidth / 3) * 1;
            containerHeight = Math.ceil(numElements / 3.05) * elementHeight;
            numVerticalGutters = Math.ceil(numElements / 3) - 1; // 3 elements per row
            verticalGutterHeight = (containerHeight - (Math.ceil(numElements / 3) * elementHeight)) / numVerticalGutters;
        }


        //Fetch our canvas
        var canvas = document.getElementById('world');

        //Setup Matter JS
        var engine = Matter.Engine.create();
        var world = engine.world;
        var render = Matter.Render.create({
            canvas: canvas,
            engine: engine,
            options: {
                width: window.innerWidth,
                height: containerHeight,
                background: '#000',
                wireframes: true,
                showAngleIndicator: false,
                pixelRatio: mutliplyer,
            }
        });



        //Add a floor
        var floor = Matter.Bodies.rectangle(window.innerWidth * 4, containerHeight, window.innerWidth * 8, 4, {
            isStatic: true,
            render: {
                visible: false
            }
        });

        Matter.World.add(world, floor);

        var left_wall = Matter.Bodies.rectangle(0, containerHeight / 2, 4, containerHeight, {
            isStatic: true,
            render: {
                visible: false
            }
        });

        Matter.World.add(world, left_wall);

        right_wall = Matter.Bodies.rectangle(window.innerWidth, containerHeight / 2, 4, containerHeight, {
            isStatic: true,
            render: {
                visible: false
            }
        });

        Matter.World.add(world, right_wall);


        this.document.body.addEventListener('mousemove', mousemove);
        this.document.body.addEventListener('touchstart', mousemove);

        function mousemove(e) {

            if(loaded){
            var mX = 0;
            var mY = 0;

            if (e.touches) {
                mX = e.touches[0].pageX;
                mY = e.touches[0].pageY;
            } else {
                mX = e.pageX;
                mY = e.pageY;
            }

            const bodies = Matter.Composite.allBodies(engine.world);
            var bodiesUnder = Matter.Query.point(bodies, {
                x: mX,
                y: mY
            });

            for (let i = 0; i < bodies.length; i++) {

                const body = bodies[i];
                var inarray = false;

                for (let b = 0; b < bodiesUnder.length; b++) {
                    if (body.id == bodiesUnder[b].id) {
                        inarray = true;
                    }
                }

                if (inarray) {

                    if (objs[body.label] && objs[body.label].product_button) {
                       
                        if (objs[body.label].product_image) {
                            objs[body.label].product_image.style.filter = 'brightness(0) invert(1) grayscale(1)';
                        }

                        objs[body.label].product_button.style.opacity = 1;
                    }
                } else {
                    if (objs[body.label] !== undefined) {

                        if(objs[body.label].product_image_loaded === undefined){

                           let img = objs[body.label].product_image.querySelector('img');

                           if(img.src !== undefined && img.src !== ''){
                            objs[body.label].product_image_loaded = true;
                           }else{
                            img.src = objs[body.label].img;
                           }

                        //    console.log(img.src);

                        }
                       
                        if(objs[body.label].product_image.querySelector('img') && objs[body.label].product_image.src == ''){
                            objs[body.label].product_image_loaded = objs[body.label].img;
                        }
        

                        if (objs[body.label].product_button) {
                            objs[body.label].product_button.style.opacity = 0;
                        }

                        if (objs[body.label].product_image) {
                            objs[body.label].product_image.style.filter = 'unset';
                        }
                    }
                }
            }
        }
        }

        //Start the engine

        Matter.Runner.run(engine);
        Matter.Render.run(render);

        objs = shuffle(objs);

        for (let a = 0; a < objs.length; a++) {

            let image = new Image();

            image.onload = function() {
              
                var elementWidth = window.innerWidth / 1;
                var row = Math.floor(a / 1); 
                var col = a % 1;

                // console.log(a, col,row, elementWidth,  elementHeight);

                if (window.innerWidth > 800) {
                    row = Math.floor(a / 3); 
                    col = a % 3;
                    elementWidth = window.innerWidth / 3;
                }

                const y = (row * (elementHeight + verticalGutterHeight)) + elementHeight / 2;
                const x = (col * (elementWidth + gutterWidth)) + (Math.random() * elementWidth);

                var obj = createBoundaryFromSVGPath(objs[a], a, x, y);
                objs[a].body = obj;
                bodies.push(obj);
                Matter.World.add(world, obj);

            };

            image.src = objs[a].img;

        }


        fetchProducts();

    }


    this.setTimeout(function() {
        document.querySelector('.description').style.opacity = 1;
        document.querySelector('.info').style.opacity = 1;
    }, 500);

    this.setTimeout(function() {
        document.querySelector('h1').style.opacity = 1;
    }, 1500);

    if (!document.body.classList.contains('initial')) {

        this.setTimeout(function() {
          
            for (let a = 0; a < objs.length; a++) {

                objs[a].body.isStatic = true;
                if(objs[a].product_image){
                    objs[a].product_image.style.opacity = 1;
                    loaded = true;
                }
            }

        }, 3000);
    }

    if (!document.body.classList.contains('initial')) {
        
        this.setTimeout(function() {
            document.querySelector('h1').style.opacity = 0;
            document.querySelector('h1').style.display = 'none';
            document.querySelector('canvas').style.pointerEvents = 'all';
        }, 4000);

    }




    if(!touchDev){
        
        window.addEventListener("resize", resize);
        window.addEventListener("resize", debounce(function() {
            debounceresize();
        }, staticTime));
    
    } else{
        
        var orientation = false;
        
        if(window.innerWidth > window.innerHeight){
            orientation = true;
        }

        window.addEventListener("resize", function(){
           
            let newOrient = false;
            if(window.innerWidth > window.innerHeight){
                newOrient = true;
            }

            if(orientation !== newOrient){
                orientation = newOrient;
                resize();
                setTimeout(function(){
                    debounceresize();
                }, 2000);
               
            }
            
        });
          
        //  window.addEventListener("resize", resize);
    }

    function resize() {

        render.bounds.max.x = window.innerWidth;
        render.options.width = window.innerWidth;
        render.canvas.width = window.innerWidth;

        Matter.Render.setPixelRatio(render, mutliplyer);


        for (let a = 0; a < objs.length; a++) {

            if (objs[a].body.isStatic) {
                objs[a].body.isStatic = false;

                if (objs[a].product_button && objs[a].body) {
                    objs[a].product_button.style.display = 'none';
                }
            }

        }

    }

    function debounceresize() {

        Matter.Render.setPixelRatio(render, mutliplyer);
        document.body.style.height = containerHeight + 'px';

        for (let a = 0; a < objs.length; a++) {
            objs[a].body.isStatic = true;
        }
    }

});



function createBoundaryFromSVGPath(obj, i, x, y) {

    var path = obj.svgCode;
    var imgUrl = obj.img;

    var imgScale = (window.innerWidth / 1000) / 1.8;

    if (window.innerWidth > 800) {
        var imgScale = (window.innerWidth / 1000) / 4.9;
    }


    let obj_matter = Matter.Bodies.rectangle(
        x,
        y,
        1,
        1, {
            label: i,
            render: {
                sprite: {
                    texture: imgUrl,
                    xScale: imgScale,
                    yScale: imgScale,
                },
                fillStyle: '#fff'
            },
            mass: 10,
            density: 10,
            friction: 10,
            isStatic: false,
        }
    );

    /// Just use this code and get the same path as image
    var p = path.split(' ');

    p = p.map(function(pathData) {
        pathData = Math.max(pathData, 0);
        return (pathData * imgScale * 1).toFixed(0);
    });

    //   console.log(p);


    var myVertices = Matter.Vertices.fromPath(p.join(' '));
    Matter.Body.setVertices(obj_matter, myVertices);

    return obj_matter;
}


function shuffle(array) {
    let currentIndex = array.length,
        randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]
        ];
    }

    return array;
}



function debounce(func, delay) {
    let timeoutId;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(context, args);
        }, delay);
    };
}



if (!document.body.classList.contains('initial')) {
    document.addEventListener('scroll', function() {
        document.querySelector('.description').style.display = 'none';
        document.querySelector('.info').style.display = 'none';
         document.querySelector('h1').style.display = 'none';
    });
    
}

if (!document.body.classList.contains('initial')) {

    document.addEventListener('scroll', debounce(function() {
        document.querySelector('.description').style.display = 'block';
        document.querySelector('.info').style.display = 'block';
    }, 1000));

}

async function fetchProducts() {
    try {

        const response = await fetch('api_products.php');
        const data = await response.json();

        if (response.ok) {
            displayProducts(data.products, data.prices);
        } else {
            console.error('Error fetching products:', data.error);
        }

    } catch (error) {
        console.error('Error fetching products:', error.message);
    }
}


function displayProducts(products, prices) {
    const productsContainer = document.querySelector('.products');

    products.forEach(product => {

        for (let a = 0; a < objs.length; a++) {



            if (!objs[a].product && objs[a].stripe_id === product.id) {

                objs[a].product = product;

                const productPrice = prices.find(price => price.product === product.id);

                // console.log(product.id);
                if (productPrice) {

                    const productDiv = document.createElement('div');
                    productDiv.style.position = 'absolute';
                    
                    if (objs[a].body) {
                        productDiv.style.left = Math.round(objs[a].body.position.x) + 'px';
                        productDiv.style.top = Math.round(objs[a].body.position.y) + 'px';
                    }

                    objs[a].product_button = productDiv;


                    productDiv.className = 'product';

                    const productName = document.createElement('h2');
                    productName.textContent = product.name;
                    productDiv.appendChild(productName);

                    const productDescription = document.createElement('p');
                    productDescription.textContent = `${product.description}`;
                    productDiv.appendChild(productDescription);

                    const productPriceDisplay = document.createElement('p');
                    productPriceDisplay.textContent = `£${(productPrice.unit_amount / 100).toFixed(2)}`;
                    productDiv.appendChild(productPriceDisplay);

                    const buyNowButton = document.createElement('button');
                    // console.log(product);
                    if (productPrice.active && product.active) {
                        buyNowButton.textContent = 'Buy Now';
                    } else {
                        buyNowButton.textContent = 'Sold';
                        buyNowButton.disabled = true;
                    }

                    buyNowButton.onclick = async() => {
                        document.querySelector('.loading').style.display = 'flex';
                        try {
                            const response = await fetch('create_checkout_session.php', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    priceId: productPrice.id,
                                }),
                            });

                            const data = await response.json();

                            if (response.ok) {
                                const sessionId = data.id;
                                await stripe.redirectToCheckout({
                                    sessionId
                                });
                            } else {
                                document.querySelector('.loading').style.display = 'none';
                                console.error('Error creating Checkout Session:', data.error);
                            }
                        } catch (error) {
                            console.error('Error creating Checkout Session:', error.message);
                            document.querySelector('.loading').style.display = 'none';
                        }

                    };

                    const productImag = document.createElement('div');
                    productImag.style.position = 'absolute';
                    productImag.style.display = 'flex';
                    productImag.style.justifyContent = 'center';
                    productImag.style.alignItems = 'center';
                    productImag.style.transformOrigin = 'center center';
                    productImag.style.opacity = 0;
            
                    const prodImg = document.createElement('img');
                    objs[a].product_image = productImag;



                    if (objs[a].body) {
                        prodImg.src = objs[a].img;
                    }

                    prodImg.style.maxWidth = '100%';
                    prodImg.style.maxHeight = '100%';




                    productImag.appendChild(prodImg);
                    productsContainer.appendChild(productImag);

                    productDiv.appendChild(buyNowButton);
                    productsContainer.appendChild(productDiv);
                }

            }
        }
    });
}





function step() {

    for (let a = 0; a < objs.length; a++) {
        if (objs[a].product_image && objs[a].body) {
            matchBodyProperties_new(objs[a], objs[a].body, objs[a].product_image);
        }
    }
    
    if(right_wall){
        
        var pos = right_wall.position.x;
        var newPos = 0;

        // console.log(pos, Math.round((window.innerWidth - pos) / 30),  pos - Math.round((window.innerWidth - pos) / 30));

        if(window.innerWidth >= pos){
            newPos = window.innerWidth;
        }else{

            if(pos - window.innerWidth <=  20){
                newPos =  window.innerWidth;
            }else{
                newPos = pos - 20;
            }
        }


        Matter.Body.set(right_wall, "position", {
            x: newPos,
            y: containerHeight / 2
        });

    }

    window.requestAnimationFrame(step);

}


window.requestAnimationFrame(step);

function matchBodyProperties_new(obj, sourceBody, overlayImage) {

    var sourceRotation = sourceBody.angle;

    var sourcePositionX = sourceBody.position.x;
    var sourcePositionY = sourceBody.position.y;

    var width = obj.width * sourceBody.render.sprite.xScale;
    var height = obj.height * sourceBody.render.sprite.yScale;

    overlayImage.style.width = width + 'px';
    overlayImage.style.height = height + 'px';

    overlayImage.style.left = sourcePositionX - width / 2 + "px";
    overlayImage.style.top = sourcePositionY - height / 2 + "px";

    overlayImage.style.transform = "rotate(" + sourceRotation + "rad)";

    if (obj.product_button) {
        obj.product_button.style.left = Math.round(sourceBody.position.x) + 'px';
        obj.product_button.style.top = Math.round(sourceBody.position.y) + 'px';
        obj.product_button.style.display = 'block';
    }

}